var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbstractWellness1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "600px",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#667eea",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#764ba2",
      stopOpacity: 0.2
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,150 Q200,50 400,150 T800,150 L800,600 L0,600 Z",
    fill: "url(#gradient1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,200 Q200,100 400,200 T800,200",
    stroke: "#667eea",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,250 Q200,150 400,250 T800,250",
    stroke: "#764ba2",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 300,
    r: 5,
    fill: "#667eea",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 350,
    r: 5,
    fill: "#764ba2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 300,
    r: 5,
    fill: "#667eea",
    opacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractWellness1);
export default __webpack_public_path__ + "static/media/abstract-wellness1.efa4a7199c090fa632e924437202a74e.svg";
export { ForwardRef as ReactComponent };